'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = function (options) {
    var _this = this;

    try {
        ga('create', {
            trackingId: options.trackingId,
            cookieDomain: options.cookieDomain
        });

        ga('require', 'ec'); //ecommerce plugin
        /**
         * Impl. of pushEvent method
         * @param {EventType} eventType
         * @param payload
         */
        var gaSendPropArry = ['eventCategory', 'eventAction', 'eventValue'];
        this.pushEvent = function (eventType, payload) {
            if (eventType === 'PAGE_VIEW') {
                this.setPage(payload.url);
                ga('send', 'pageview'); //requires setPage to be called before in order to send correct page (see helper.js)
            } else {
                if (payload.eventCategory && payload.eventAction) {
                    var eventObj = { hitType: 'event', eventLabel: eventType };

                    gaSendPropArry.forEach(function (prop) {
                        //builds obj
                        if (typeof payload[prop] != 'undefined') {
                            eventObj[prop] = payload[prop];
                        }
                    });

                    ga('send', eventObj);
                } else {
                    console.warn('ga send event failed. category or action not provided in payload');
                }
            }
        };

        this.setPage = function (pagePath) {
            ga('set', 'page', pagePath);
        };

        this.setUserId = function (userId) {
            ga('set', 'userId', userId);
        };

        this.createNewSession = function () {
            console.log('createNewSession not implemented');
        };

        this.ec = { //GA wipes data on every event send. This means product adds and otherwise need to be reran every time. when a new update is needed
            actionTypes: { click: 'click', detail: 'detail', add: 'add', remove: 'remove', checkout: 'checkout',
                checkout_option: 'checkout_option', purchase: 'purchase', refund: 'refund', promo_click: 'promo_click' },
            dataTypes: { //['type','required']
                impression: { //product seen/loaded on page
                    id: ['string', true], //product id
                    name: ['string', true], //product name
                    list: ['string', false], //list or collection product is part of(e.g. Search Results)
                    brand: ['string', false], //brand of product (likely unused for wendys)
                    category: ['string', false], //The category to which the product belongs (e.g. Apparel). Use / as a delimiter to specify up to 5-levels of hierarchy (e.g. Apparel/Men/T-Shirts).
                    variant: ['string', false], //The variant of the product (e.g. Black).
                    position: ['number', false], //The product's position in a list or collection (e.g. 2).
                    price: ['number', false] //The price of a product (e.g. 29.20).
                },
                product: {
                    id: ['string', true], //product id
                    name: ['string', true], //product name
                    brand: ['string', false], //brand of product (likely unused for wendys)
                    category: ['string', false], //The category to which the product belongs (e.g. Apparel). Use / as a delimiter to specify up to 5-levels of hierarchy (e.g. Apparel/Men/T-Shirts).
                    variant: ['string', false], //The variant of the product (e.g. Black).
                    price: ['number', false], //The price of a product (e.g. 29.20).
                    quantity: ['number', false], //The quantity of a product (e.g. 2).
                    coupon: ['string', false], //The coupon code associated with a product (e.g. SUMMER_SALE13).
                    position: ['number', false] //The product's position in a list or collection (e.g. 2).
                },
                action: {
                    id: ['string', false], //The transaction ID (e.g. T1234). *Required if the action type is purchase or refund.
                    affiliation: ['string', false], //The store or affiliation from which this transaction occurred (e.g. Google Store).
                    revenue: ['number', false], //total aka total the customer will see on their card
                    tax: ['number', false],
                    shipping: ['number', false],
                    coupon: ['string', false],
                    list: ['string', false],
                    step: ['number', false], //A number representing a step in the checkout process. Optional on checkout actions.
                    option: ['string', false] //Additional field for checkout and checkout_option actions that can
                    // describe option information on the checkout page, like selected payment method. (set in the admin panel. checkout funnel steps
                }
            },
            addImpression: function addImpression(obj) {
                var validObj = _this.ec.validateAndBuildObj('impression', obj);
                if (validObj) ga('ec:addImpression', validObj);
            },
            addProduct: function addProduct(obj) {
                var validObj = _this.ec.validateAndBuildObj('product', obj);
                if (validObj) ga('ec:addProduct', validObj);
            },
            removeProduct: function removeProduct(obj) {
                var validObj = _this.ec.validateAndBuildObj('product', obj);
                if (validObj) ga('ec:removeProduct', validObj);
            },
            setAction: function setAction(string, obj) {
                //when doing checkout flows sending just string== 'checkout_option' and obj {step: stepNumber, option: someString} will help with incrementing steps
                //first checkout ping to initialize set string == 'checkout' and obj {step: 1, option: someString}
                if (_this.ec.actionTypes[string]) {
                    if (obj) {
                        var validObj = _this.ec.validateAndBuildObj('action', obj);
                        if (validObj) ga('ec:setAction', string, validObj);
                    } else {
                        ga('ec:setAction', string);
                    }
                } else {
                    console.warn('"' + string + '" doesn\'t exist in actionTypes when setting ga ec:setAction. Please make sure actionTypes are one to one {a:\'a\'}');
                }
            },
            sendGenericEcomEvent: function sendGenericEcomEvent() {
                //use this to send data. DO NOT CALL AFTER EACH IMPRESSION ADD IF BUILDING A NUMBER OF THEM. CALL AFTER ADDING THEM ALL
                ga('send', 'event', 'ecommerce', 'generic');
            },
            validateAndBuildObj: function validateAndBuildObj(type, obj) {
                var objKeys = Object.keys(obj) || [];
                var dataKeys = Object.keys(_this.ec.dataTypes[type]);
                var newObj = {};
                var error = [];

                dataKeys.forEach(function (key) {
                    var validationArr = _this.ec.dataTypes[type][key];
                    if (!(_typeof(obj[key]) === validationArr[0] || typeof obj[key] === 'undefined')) error.push(key + ' is invalid for ec:' + type);

                    if (validationArr[1] && !(obj[key] || obj[key] === 0)) error.push(key + ' is required for ec:' + type);

                    if (!(typeof obj[key] === 'undefined')) {
                        newObj[key] = obj[key];
                    }

                    var idxOfKey = objKeys.indexOf(key);
                    if (idxOfKey > -1) objKeys.splice(idxOfKey, 1);
                });

                objKeys.forEach(function (key) {
                    if (!obj[key]) {
                        return;
                    }
                    if (key.includes('metric')) {
                        if (_typeof(obj[key]) === "object" || typeof obj[key] === "number") {
                            newObj[key] = obj[key];
                        } else {
                            console.warn(key + ' is not a valid type within custom metric');
                        }
                    } else if (key.includes('dimension')) {
                        if (typeof obj[key] === "string") {
                            newObj[key] = obj[key];
                        } else {
                            console.warn(key + ' is not a valid type within custom dimension');
                        }
                    } else {
                        console.warn(key + ' is not a valid prop within ec:' + type + ' object');
                    }
                });

                if (error.length) {
                    error.forEach(function (err) {
                        console.warn(err);
                    });
                    return false;
                } else {
                    return newObj;
                }
            }

        };
    } catch (err) {
        //TODO return something indicating that _ga hasn't been loaded to the global window
        console.log('ga err..', err);
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/analytics/GoogleProvider.js
// module id = 859
// module chunks = 0